import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { BreakPointToken } from '../../hooks/useMediaQuery';
import { NoGapSupport } from '../../lib/utils/mixins';
import {
	colours,
	desktopGridGaps,
	mobileGridGap,
	size_12,
	size_16,
	size_20,
	size_24,
	size_8,
	submitBtnWidthDesktop,
	tabletGridGaps
} from './forms.styles';

export const inputWidths = {
	tablet: `calc((100% / 3) - ${2 * (tabletGridGaps.horizontal / 3)}px)`,
	desktop: `calc(((100% - ${submitBtnWidthDesktop}px) / 5) - ${desktopGridGaps.horizontal}px)`
};

export const hotelInputWidths = {
	tablet: `calc((100% / 2) - ${tabletGridGaps.horizontal / 2}px)`,
	desktop: `calc(((100% - ${submitBtnWidthDesktop}px) / 5) - ${desktopGridGaps.horizontal}px)`
};

export const buttonWidths = {
	tablet: `100%`,
	desktop: `calc(((100% - ${submitBtnWidthDesktop}px) / 5) - ${desktopGridGaps.horizontal}px)`
};

export const flushOption = css`
	width: max-content;

	${NoGapSupport(
		() => css`
			margin-top: ${size_20}px;

			@media (min-width: ${BreakPointToken.MdMin}px) {
				margin-top: 0;
			}
		`
	)}
`;

export const mainColumn = css`
	flex: 0 0 100%;

	@media (min-width: ${BreakPointToken.MdMin}px) {
		flex: 0 0 ${inputWidths.tablet};
	}

	@media (min-width: ${BreakPointToken.LgMin}px) {
		flex: 0 0 ${inputWidths.desktop};
	}

	&:first-of-type {
		margin-top: ${size_16 - mobileGridGap}px;

		@media (min-width: ${BreakPointToken.MdMin}px) {
			margin: 0;
		}
	}

	${NoGapSupport(
		() => css`
			@media (min-width: ${BreakPointToken.MdMin}px) {
				margin-top: ${tabletGridGaps.vertical}px;
				margin-left: ${tabletGridGaps.horizontal}px;

				&:nth-of-type(3),
				&:first-of-type {
					margin-left: 0;
				}
			}

			@media (min-width: ${BreakPointToken.LgMin}px) {
				margin-top: ${desktopGridGaps.vertical}px;
				margin-left: ${desktopGridGaps.horizontal}px;

				&:nth-of-type(3) {
					margin-left: ${desktopGridGaps.horizontal}px;
				}

				&:first-of-type {
					margin-left: 0;
				}
			}
		`
	)}
`;

export const flyingColumn = css`
	flex: 0 0 100%;

	@media (min-width: ${BreakPointToken.MdMin}px) {
		flex: 0 0 ${hotelInputWidths.tablet};
	}

	@media (min-width: ${BreakPointToken.LgMin}px) {
		flex: 0 0 ${hotelInputWidths.desktop};
	}
`;

export const tripType = css`
	${mainColumn}

	@media (min-width: ${BreakPointToken.LgMin}px) {
		flex: 0 0 ${inputWidths.desktop};
	}

	input {
		cursor: pointer;
	}
`;

export const cabin = css`
	flex: 0 0 auto;
	margin: 0;
`;

export const rewardCabin = css`
	order: 4;
	flex: 0 0 100%;
	margin: ${size_20 - mobileGridGap}px 0;

	${NoGapSupport(
		() => css`
			margin: ${size_20}px 0 ${size_20 - mobileGridGap}px;
		`
	)}

	@media (min-width: ${BreakPointToken.MdMin}px) {
		order: unset;
		flex: 0 0 auto;
		margin: 0;
	}
`;

export const last = css`
	@media (min-width: ${BreakPointToken.MdMin}px) and (max-width: ${BreakPointToken.MdMax}px) {
		margin-inline-end: 60%;
	}
`;

export const paymentType = css`
	order: 4;
	flex: 0 0 100%;
	margin: ${size_20 - mobileGridGap}px 0;

	${NoGapSupport(
		() => css`
			margin: ${size_20}px 0 ${size_20 - mobileGridGap}px;
		`
	)}

	@media (min-width: ${BreakPointToken.MdMin}px) and (max-width: ${BreakPointToken.MdMax}px) {
		margin-inline-end: 40%;
	}

	@media (min-width: ${BreakPointToken.MdMin}px) {
		order: unset;
		flex: 0 0 auto;
		margin-top: 0;
		margin-bottom: 0;
	}
`;

export const multiCityButton = css`
	order: 5;
	margin-top: 0;

	@media (min-width: ${BreakPointToken.MdMin}px) {
		flex: 0 0 auto;
	}

	@media (min-width: ${BreakPointToken.LgMin}px) {
		flex: 0 0 auto;
	}
`;

export const multiCityDiscount = css`
	order: 6;
`;

export const multiCityInput = css`
	@media (min-width: ${BreakPointToken.MdMin}px) {
		min-width: 40%;
	}

	@media (min-width: ${BreakPointToken.LgMin}px) {
		min-width: 25%;
	}
`;

export const multiCtaButton = css`
	display: grid;
	row-gap: ${size_16}px;

	> button[data-test-attr='target-holiday-search-button'] {
		display: none;
		padding: ${size_12}px ${size_8}px;
	}
`;

export const modalContainer = css`
	footer {
		border-top: 1px solid var(--token-color-colour-border-minimal);
	}
`;

export const roomsModalHeader = css`
	display: flex;
	align-items: center;
	gap: ${size_12}px;

	&:header {
		padding: ${size_24}px;
	}
`;

export const roomsModalText = css`
	margin-bottom: ${size_24}px;
`;

export const roomsModal = css`
	padding: 0 ${size_24}px;
`;
